export const FILE_NAME_DATE_FORMAT = 'YYYY-MM-DD';
export const RISKS_FILE_NAME = '_Risk_assessment_';
export const riskHeaders = {
	canvasEngagementId: 'canvasEngagementId',
	engagementDescription: 'engagementDescription',
	accountName: 'accountName',
	pspIndexTitle: 'pspIndexTitle',
	accountTypeId: 'accountTypeId',
	assertionName: 'assertionName',
	inherentRiskTypeName: 'inherentRiskTypeName',
	controlRiskTypeName: 'controlRiskTypeName',
	craValue: 'craValue',
	riskTypeName: 'riskTypeName',
	riskName: 'riskName',
	taskTypeName: 'taskTypeName',
	taskNamePrefix: 'taskNamePrefix',
	knowledgeTaskTitle: 'knowledgeTaskTitle',
	taskNameSuffix: 'taskNameSuffix',
	taskStatus: 'taskStatus',
	relatedTasks: 'relatedTasks'
};
